/**
 * BASE_ARCHETYPE
 *
 * The foundational statistical profile for all Orchestral Archetypes.
 * Implements the "Standard Orchestral" profile (Balanced/Narrative).
 *
 * Sub-Archetypes should spread this and override specific keys.
 */

export const BASE_ARCHETYPE = {
    // Harmonic Rhythm: Moderate.
    // 2.0 bars per chord is the cinematic standard.
    harmonicRhythm: {
        target: 2.0,
        tolerance: 1.0,
        weight: 0.2
    },

    // Harmonic Consonance: Generally Consonant.
    harmonicConsonance: {
        polarity: 'consonant',
        weight: 0.1
    },

    // Voice Distribution: Balanced Narrative.
    // Moderate Low/Mid/High presence.
    voiceDistribution: {
        low: 0.30,
        mid: 0.35,
        high: 0.35,
        tolerance: 0.20,
        tuttiThreshold: 0.85,
        weight: 0.3
    },

    // Dynamic Range: Expressive but controlled.
    dynamicRange: {
        minVariance: 0.12,
        targetVariance: 0.20,
        dynamicShape: 'linear',
        weight: 0.3
    },

    // Interval Entropy: Melodic flow.
    intervalEntropy: {
        stepRatio: 0.60,
        tolerance: 0.20,
        weight: 0.2
    },

    // Rhythmic Lock: Standard Orchestral tightness.
    rhythmicLock: {
        target: 0.70,
        weight: 0.1
    },

    // Narrative Arc: Standard Build-Climax-Outro.
    narrativeArc: {
        weight: 0.2
    },

    // Motivic Repetition: Thematic cohesion.
    motivicRepetition: {
        target: 0.5,
        tolerance: 0.2,
        weight: 0.2
    }
};

/**
 * SLOW_ARCHETYPE
 *
 * For atmospheric, romantic, or dark genres.
 * Traits: Slower Harmonic Rhythm, Lower Dynamic Variance requirement.
 */
export const SLOW_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    harmonicRhythm: {
        ...BASE_ARCHETYPE.harmonicRhythm,
        target: 4.0 // Slow evolution
    },

    dynamicRange: {
        ...BASE_ARCHETYPE.dynamicRange,
        minVariance: 0.10 // Allow smoother textures
    }
};

/**
 * ACTIVE_ARCHETYPE
 *
 * For rhythmic, busy, or driving genres.
 * Traits: Fast Harmonic Rhythm, High Rhythmic Lock.
 */
export const ACTIVE_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    harmonicRhythm: {
        ...BASE_ARCHETYPE.harmonicRhythm,
        target: 1.0 // Fast changes (1 bar or less)
    },

    rhythmicLock: {
        ...BASE_ARCHETYPE.rhythmicLock,
        target: 0.90, // Tight sync
        weight: 0.3
    }
};
